import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ps-outline-icon',
  templateUrl: './ps-outline-icon.component.html',
  styleUrls: ['./ps-outline-icon.component.scss']
})
export class PsOutlineIconComponent {
  @Input() name = 'circle';
}
